import style from './auth.module.scss';

const registerFields = (notHasAccNum,handleCheckBox) => {
  const { form100w, helpMargin, passInput } = style;

  const pattern = '^[A-Za-z0-9-/_/-/ñ/Ñ]+$';

  const passConfirm = ({ getFieldValue }) => ({
    validator(_, value) {
      if (!value || getFieldValue('userPassword') === value) {
        return Promise.resolve();
      }
      return Promise.reject(
        new Error('¡Las contraseñas que ingresó no coinciden!'),
      );
    },
  });

  const fields = [
    {
      item: {
        label: '',
        name: 'email',
        rules: [
          {
            required: true,
            message: 'Por favor ingrese su email',
          },
        ],
      },
      input: {
        placeholder: 'Email',
      },
      inputTag: 'Input'
    },
    {
      item: {
        label: '',
        name: 'accNumber',
        rules: [
          {
            required: !notHasAccNum,
            message: 'Por favor ingrese su numero de cuenta',
          },
        ],
      },
      input: {
        placeholder: 'Número de cuenta',
        disabled: notHasAccNum ,
      },
      inputTag: 'Input'
    },
    {
      item: {
        label: 'No tengo número de cuenta'
      },
      input: {
        onChange: handleCheckBox
      },
      inputTag: 'Checkbox'
    },
    {
      item: {
        label: '',
        name: 'phName',
        rules: [
          {
            required: true,
            message: 'Por favor ingrese el nombre de la farmacia',
          },
        ],
      },
      input: {
        placeholder: 'Nombre de la farmacia',
      },
      inputTag: 'Input'
    },
    {
      item: {
        label: '',
        name: 'phOwner',
        rules: [
          {
            required: true,
            message: 'Por favor ingrese el nombre del propietario',
          },
        ],
      },
      input: {
        placeholder: 'Nombre del propietario',
      },
      inputTag: 'Input'
    },
    {
      item: {
        label: '',
        name: 'phCellPhone',
        rules: [
          {
            required: true,
            message: 'Por favor ingrese el celular del propietario',
          },
        ],
        help: 'El número debe incluir codigo de area sin el 0 y el numero sin el 15',
        className: helpMargin
      },
      input: {
        placeholder: 'Celular del propietario',
        type: 'number',
        className: form100w
      },
      inputTag: 'Input'
    },
    {
      item: {
        label: '',
        name: 'phNameResponsible',
        rules: [
          {
            required: true,
            message:
              'Por favor ingrese nombre y apellido del responsable de compras',
          },
        ],
      },
      input: {
        placeholder: 'Nombre y apellido del responsable de compras',

      },
      inputTag: 'Input'
    },
    {
      item: {
        label: '',
        name: 'phResponsibleCellPhone',
        rules: [
          {
            required: 'true',
            message:
              'Por favor ingrese el número celular del responsable de las compras',
          },
        ],
        help: 'El número debe incluir codigo de area sin el 0 y el numero sin el 15',
        className: helpMargin,
      },
      input: {
        placeholder: 'Número celular del responsable de las compras',
        type: 'number',
      },
      inputTag: 'Input'
    },
    {
      item: {
        label: '',
        name: 'userPassword',
        help: 'la contraseña tiene que tener entre 6 y 12 caracteres, simbolos permitidos: - _ ',
        rules: [
          {
            required: true,
            message: 'Por favor escriba su contraseña',
          },
          {
            min: 6,
            message: 'Largo de contraseña mínimo 6 caracteres',
          },
          {
            pattern: pattern,
            message: 'los unicos simbolos permitidos son - y _'
          },
          {
            max: 12,
            message: 'Máximo de caracteres permitidos es 12'
          }
        ],
        className: helpMargin,
      },
      input: {
        className: passInput,
        placeholder: 'Contraseña',
        maxlength: 12,
        type: 'password'
      },
      inputTag: 'Input.Password'
    },
    {
      item: {
        label: '',
        name: 'passRepeat',
        rules: [
          {
            required: true,
            message: 'Por favor confirme la contraseña',
          },
          {
            min: 6,
            message: 'Largo de contraseña mínimo 6 caracteres',
          },
          {
            max: 12,
            message: 'Máximo de caracteres permitidos es 12'
          },
          passConfirm,
        ],
      },
      input: {
        className: passInput,
        placeholder: 'Repita la contraseña',
        maxlength: 12,
        type: 'password'
      },
      inputTag: 'Input.Password'
    },
  ];
  return fields;
};

export default registerFields;
